import React from 'react'
import { MenuItem, Select } from '@material-ui/core'
import { CustomDropdownItem } from '../../constants/types'
import styled from 'styled-components'
import { atlTheme } from '../../atlTheme'
import { icons } from '../../constants/searchAssets'

const DropdownContainer = styled.div`
  display: flex;
  width: 100%;
  padding: ${atlTheme.SpacingMarginal}px 0;
`

const Icon = styled.img`
  width: ${atlTheme.SizeAvatarSmall}px;
  height: ${atlTheme.SizeAvatarSmall}px;
  align-self: center;
  margin: 0 ${atlTheme.SpacingMarginal}px;
`

const CustomSelect = styled(Select)`
  width: 100%;
  margin-right: ${atlTheme.SpacingMarginal}px;
`

interface DropdownDateSelectorProps {
  value: CustomDropdownItem
  onSelect: (newValue: CustomDropdownItem) => void
  dropdownData: CustomDropdownItem[]
}

export const DropdownDateSelector: React.FunctionComponent<DropdownDateSelectorProps> = ({
  value,
  dropdownData,
  onSelect,
}) => {
  const onSelectItem = event => {
    const itemIndex = dropdownData.findIndex(item => item.text === event.target.value)
    const selectedItem = dropdownData[itemIndex]
    onSelect(selectedItem)
  }

  return (
    <DropdownContainer>
      <Icon src={icons.calendarIcon} />
      <CustomSelect value={value.text} onChange={onSelectItem} color={'secondary'}>
        {dropdownData.map(item => {
          return <MenuItem value={item.text}>{item.text}</MenuItem>
        })}
      </CustomSelect>
    </DropdownContainer>
  )
}
